/**
 * DWT dependencies
 */
import { filterOutWhiteSpace } from '../utils/general-utils';

/**
 * WP dependencies
 */
import {
  RichText,
  useBlockProps,
  useInnerBlocksProps
} from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const {
    borderColor,
    borderStyle,
    baseStyle,
    backgroundColor,
    heading,
    headingColor,
    text,
    textColor,
    layoutStyle,
    orientationStyle,
    logo,
    buttonOption,
    socialOption
  } = attributes;

  /**
   * Handle additional logic
   */
  const styledElementClasses = filterOutWhiteSpace( [ 'logo-banner-styled-element', borderStyle ] );

  const base = baseStyle ?? '';
  const isCurved = baseStyle === 'has-curve';
  const curvedBaseWithBorder = ( isCurved && borderColor ) ? 'has-curved-border' : '';

  const layout = layoutStyle ?? '';
  const orientation = orientationStyle ?? '';
  const hasNoImage = !logo ? 'has-no-image' : '';

  /**
   * Handle styles
   */
  const bgColor = backgroundColor ? { backgroundColor } : undefined;
  const bColor = borderColor ? { borderColor } : undefined;

  const hColor = headingColor ? { color: headingColor } : undefined;
  const tColor = textColor ? { color: textColor } : undefined;

  const blockProps = useBlockProps.save({
    className: 'block__logo-banner',
    style: { ...bgColor, color: borderColor }
  });

  const { children, ...innerBlocksProps } = useInnerBlocksProps.save(
    { className: `inner-blocks-wrapper` }
  );

  /**
   * Handle element classes
   */
  const logoBannerInnerClasses = filterOutWhiteSpace( [
    'logo-banner--inner',
    layout,
    orientation,
    base,
    curvedBaseWithBorder,
    hasNoImage
  ] );

  return (
    <div { ...blockProps }>

      <div
        className={ logoBannerInnerClasses }
      >

        <div
          className={ styledElementClasses }
          style={{ ...bColor }}
        >
        </div>

        <div className='logo-banner-wrapper'>

          <div className="logo-element">
            <img className="logo"
              src={ logo.sizes?.full.url }
              alt={ heading + ' logo' }
            />
          </div>

          <div className="text-side-elements" style={{ color: '#000' }}>

            <RichText.Content
              className='heading-2 logo-banner__heading mt-0 mb-24 mx-0'
              tagName='h2'
              value={ heading }
              style={{ ...hColor }}
            />

            <RichText.Content
              className='paragraph-1 logo-banner__text font-400 my-0 mx-0'
              tagName='p'
              value={ text }
              style={{ ...tColor }}
            />

            { ( buttonOption || socialOption ) && (
              <div {...innerBlocksProps}>
                { children }
              </div>
            ) }

          </div>
        </div>
      </div>

    </div>
  );
};

export default save;
